import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import Modal from '../../../foundation/components/Modal';
import { DEFAULT_MODAL_ANIMATION } from '../../../foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../../foundation/components/Modal/Modal.types';
import SpecialInstructionsForm from '../SpecialInstructionsForm';
import './SpecialInstructionsModal.css';
var defaultProps = {
  open: false,
  specialInstructions: null,
  onSpecialInstructionsChange: null,
  onClose: null,
  onOpen: null,
  trigger: null,
  loading: false,
  animation: DEFAULT_MODAL_ANIMATION
};
export default function SpecialInstructionsModal(_ref) {
  var open = _ref.open,
    specialInstructions = _ref.specialInstructions,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    onSave = _ref.onSave,
    trigger = _ref.trigger,
    loading = _ref.loading,
    animation = _ref.animation;
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    onOpen: onOpen,
    trigger: trigger,
    open: open,
    dimmer: "inverted",
    size: "small",
    className: "special-instructions-modal",
    animation: animation
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Special Instructions"), /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("div", null, "Specific instructions (optional)"), /*#__PURE__*/React.createElement(SpecialInstructionsForm, {
    disabled: loading,
    value: specialInstructions,
    onSpecialInstructionsChange: onSpecialInstructionsChange,
    specialInstructions: specialInstructions
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    style: {
      "float": 'left'
    },
    disabled: loading,
    onClick: onClose,
    className: "special-instructions-modal-button-cancel"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    disabled: loading,
    primary: true,
    onClick: onSave
  }, "Save")));
}
SpecialInstructionsModal.defaultProps = defaultProps;